<template>
    <vForm :label-width="120" :model="formdata" inline>
        <!-- 导入模板 -->
        <div v-if="showtype == 2">
            <vFormItem
                :label="comptitle"
                prop="formdata.erpsku"
                :rules="required"
            >
                <vSelect v-model="formdata.erpsku" filterable>
                    <vOption
                        v-for="item in cangchuType"
                        :value="item.value"
                        :key="item.value"
                        >{{ item.label }}</vOption
                    >
                </vSelect>
            </vFormItem>
            <div
                v-if="erpskutitle"
                style="margin-top: -10px; margin-bottom: 10px"
                class="color-error"
            >
                {{ erpskutitle }}
            </div>
        </div>
        <div v-else-if="showtype == 7">
            <vFormItem
                :label="comptitle"
                prop="formdata.erpsku"
                :rules="required"
            >
                <vSelect v-model="formdata.erpsku" filterable>
                    <vOption
                        v-for="item in erpskuType"
                        :value="item.value"
                        :key="item.value"
                        >{{ item.label }}</vOption
                    >
                </vSelect>
            </vFormItem>
            <vFormItem label="单位" prop="formdata.unitType" :rules="required">
                <vSelect v-model="formdata.unitType" filterable>
                    <vOption
                        v-for="item in unitTypeData"
                        :value="item.value"
                        :key="item.value"
                        >{{ item.label }}</vOption
                    >
                </vSelect>
            </vFormItem>
            <div
                style="margin-top: -10px; margin-bottom: 10px"
                class="color-error"
            >
                {{ erpskutitle }}
            </div>
        </div>
        <div v-else>
            <vFormItem
                :label="comptitle"
                prop="formdata.erpsku"
                :rules="required"
            >
                <vSelect v-model="formdata.erpsku" filterable>
                    <vOption
                        v-for="item in erpskuType"
                        :value="item.value"
                        :key="item.value"
                        >{{ item.label }}</vOption
                    >
                </vSelect>
            </vFormItem>
            <div
                style="margin-top: -10px; margin-bottom: 10px"
                class="color-error"
            >
                {{ erpskutitle }}
            </div>
        </div>

        <compUpload
            v-bind="getFileProps"
            @on-close="close"
            @on-success="success"
            :warningtitle="warningtitle"
        ></compUpload>
    </vForm>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    props: [
        "erpskutitle",
        "warningtitle",
        "importType",
        "actionurl",
        "downrul",
        "comptitle",
        "showtype",
        "cangchuType",
    ],
    components: {
        compUpload: () => import("@components/templates/upload"),
    },
    data() {
        return {
            carrierCode: "",
            carrierServiceCode: "",
            labelValue: "",
            formdata: {
                erpsku: 0,
                unitType: 0,
            },
            erpskuType: [
                {
                    value: 0,
                    label: this.$t("erp.product.not_updated", {
                        defaultValue: "不处理",
                    }),
                },
                {
                    value: 1,
                    label: this.$t("erp.product.update", {
                        defaultValue: "直接更新",
                    }),
                },
            ],
            unitTypeData: [
                {
                    value: 0,
                    label: "cm/g",
                },
                {
                    value: 1,
                    label: "inch/lb",
                },
            ],

            required: [
                {
                    required: true,
                    message: this.$t("global.common.fill_requiredd", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
        };
    },
    mounted() {
        // console.log(this.importType)
    },
    computed: {
        getFileProps() {
            return {
                name: "excelFile",
                data: {
                    isUpdate: this.formdata.erpsku,
                    importType: this.importType,
                    unitType: this.formdata.unitType,
                },
                action: process.env.VUE_APP_APIURL_BOSS + this.actionurl,
                download: () => {
                    if (this.importType) {
                        this.handleWebfs(
                            process.env.VUE_APP_APIURL_BOSS + this.downrul,
                            { importType: this.importType },
                            "download"
                        );
                    } else {
                        this.handleWebfs(
                            process.env.VUE_APP_APIURL_BOSS + this.downrul,
                            {},
                            "download"
                        );
                    }
                },
            };
        },
    },
    methods: {
        close() {
            this.$emit("on-close");
        },
        success() {
            // console.log(23423)
            this.close();
            this.$emit("on-update");
        },
    },
};
</script>
